<template>
   <div class="page-wrapper">
    <div class="page-hero biometric">
        <div class="general-overlay">
            <div class="title is-2 has-text-white "> Page not found</div>
            <div class="big-text has-text-white subtitle" style="">
             <router-link to="/" class="has-text-primary">Return Home</router-link>
            </div>        
        </div>
    </div>
   </div>
</template>
<script>
export default {
    name:'biometric',
    // data(){

    // }
}
</script>





// WEBPACK FOOTER //
// src/components/contents/404.vue